import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost';
  onClick?: () => void;
  className?: string;
}
export function Button({
  children,
  variant = 'primary',
  onClick,
  className = ''
}: ButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-lg font-semibold transition-all duration-200 inline-block text-center';
  const variants = {
    primary: 'bg-mint-500 text-navy-950 hover:bg-mint-400 hover:shadow-lg hover:shadow-mint-500/20',
    secondary: 'bg-wave-500 text-white hover:bg-wave-400 hover:shadow-lg hover:shadow-wave-500/20',
    ghost: 'border-2 border-mint-500 text-mint-500 hover:bg-mint-500/10'
  };
  return <button onClick={onClick} className={`${baseStyles} ${variants[variant]} ${className}`} data-id="element-59">
      {children}
    </button>;
}